import type { AggregatedEntryDetail } from "./types";

export interface EntryDetailSource {
  activityId: string;
  activityName: string;
  directionId: string;
  note: string;
  durationMinutes: number;
}

export function aggregateEntryDetails(entries: readonly EntryDetailSource[]) {
  const details = new Map<string, AggregatedEntryDetail[]>();
  const indexes = new Map<string, Map<string, number>>();

  for (const entry of entries) {
    const note = entry.note.trim();
    const key = JSON.stringify([entry.activityId, note]);
    const directionDetails = details.get(entry.directionId) ?? [];
    const directionIndexes = indexes.get(entry.directionId) ?? new Map<string, number>();
    const existingIndex = directionIndexes.get(key);

    if (existingIndex === undefined) {
      directionIndexes.set(key, directionDetails.length);
      directionDetails.push({
        key,
        activityId: entry.activityId,
        activityName: entry.activityName,
        directionId: entry.directionId,
        note,
        minutes: entry.durationMinutes,
      });
      details.set(entry.directionId, directionDetails);
      indexes.set(entry.directionId, directionIndexes);
    } else {
      directionDetails[existingIndex].minutes += entry.durationMinutes;
    }
  }

  for (const directionDetails of details.values()) {
    directionDetails.sort((left, right) => right.minutes - left.minutes);
  }

  return details;
}
